import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import { TableHeaderProps } from "./TableHeaderProps";

const TableHeader = ({ columns, onSort, enableRowSelection, sortedColumnIndex = null, sortOrder }: TableHeaderProps) => {
    const handleSort = (columnIndex: number) => {
        if (!onSort) return;

        const isSameColumn = sortedColumnIndex === columnIndex;
        const currentOrder = sortOrder ?? "desc";
        const newOrder = isSameColumn
            ? currentOrder === "asc"
                ? "desc"
                : "asc"
            : "asc";

        onSort(columnIndex, newOrder);
    };

    return (
        <tr>
            {enableRowSelection && <th style={{ width: "50px" }}></th>}
            {columns.map((column, columnIndex) => {
                const isSortable = column.sortable !== false && !!column.title;
                const isCurrentlySorted = sortedColumnIndex === columnIndex;

                const getArrowIcon = () => {
                    if (!isCurrentlySorted) {
                        return <FaAngleDown />;
                    }
                    const order = sortOrder ?? "asc";
                    return order === "asc" ? <FaAngleUp /> : <FaAngleDown />;
                };

                return (
                    <th
                        key={`table-head-cell-${columnIndex}`}
                        style={{ width: column.width || "auto", minWidth: column.minWidth }}
                        aria-sort={isCurrentlySorted ? (sortOrder === "desc" ? "descending" : "ascending") : undefined}
                    >
                        {column.title}
                        {onSort && isSortable ? (
                            <button
                                type="button"
                                onClick={() => handleSort(columnIndex)}
                                className="sortIcon btn btn-link p-0"
                                aria-label={`${column.title}: ${isCurrentlySorted && sortOrder === "asc" ? "descending" : "ascending"}`}
                            >
                                {getArrowIcon()}
                            </button>
                        ) : undefined}
                    </th>
                );
            })}
        </tr>
    );
};

export default TableHeader;
